<template>
	<!-- Footer -->
	<footer class="bg-dark text-center text-white">
		<!-- Grid container -->
		<div class="container py-5">
			<!-- Section: Social media -->
			<section>
				<div class="text-center" style="font-size: small">
					<router-link :to="{ name: 'terminos' }" class="text-white"
						>Términos y Condiciones</router-link
					>
					|
					<router-link :to="{ name: 'privacidad' }" class="text-white"
						>Aviso de Privacidad</router-link
					>
					|
					<router-link :to="{ name: 'legales' }" class="text-white"
						>Legales</router-link
					>
				</div>
				<div class="mt-2" style="font-size: small">
					© Copyright 2021 Exxon Mobil Corporation. All Rights Reserved.
				</div>
			</section>
			<!-- Section: Links -->
		</div>
	</footer>
	<!-- Footer -->
</template>
<script>
export default {
	name: "footerx",
};
</script>

<style>
</style>